import React, { useState } from 'react';
import { Modal, Button } from 'react-bootstrap';
import { QrReader } from 'react-qr-reader';
import { useTranslation } from 'react-i18next';

const QRScannerModal = ({ show, onHide, onScan }) => {
    const { t } = useTranslation();
    const [error, setError] = useState('');

    const handleScan = (result) => {
        if (result) {
            onScan(result?.text);
            onHide();
        }
    };

    const handleError = (err) => {
        setError(err?.message || 'Error scanning QR code');
    };

    return (
        <Modal show={show} onHide={onHide} size="lg" centered>
            <Modal.Header closeButton>
                <Modal.Title>{t('Scan QR Code')}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div style={{ width: '100%', maxWidth: '500px', margin: '0 auto' }}>
                    <QrReader
                        constraints={{ facingMode: 'environment' }}
                        onResult={handleScan}
                        onError={handleError}
                        style={{ width: '100%' }}
                    />
                </div>
                {error && <div className="text-danger mt-2">{error}</div>}
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onHide}>
                    {t('Close')}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default QRScannerModal; 